import type { ReactNode } from 'react'
import { AlertCircleIcon } from '@systemeio/icons'
import { cn } from 'cn'
import { useTranslation } from 'next-i18next/pages'

interface AttachmentFailedPreviewProps {
  className?: string
}

const AttachmentFailedPreview = ({ className }: AttachmentFailedPreviewProps): ReactNode => {
  const { t } = useTranslation()

  return (
    <div
      className={cn(
        `flex h-full max-w-36 flex-col items-center justify-center gap-1 rounded-lg border border-text-secondary/30 p-5`,
        className,
      )}
    >
      <AlertCircleIcon className="size-8 text-text-error" />
      <span className="text-center text-sm text-text-secondary">
        {t('post.attachments.file_upload_failed')}
      </span>
    </div>
  )
}

export default AttachmentFailedPreview
